import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { EndPointService } from 'src/app/core/services/end-point.service';
import { CompanyStylingWrapper } from '../models/CompanyStylingWrapper';
import { CompanyStyling } from '../models/CompanyStyling';

@Injectable({
  providedIn: 'root'
})
export class CompanyStylingSettingsService {
  private _apiUrl = '/api/company/styling';

  constructor(private _endPointService: EndPointService) {
    this.registerEndPoints();
  }

  private registerEndPoints(): void {
    this._endPointService.registerEndPoint<CompanyStyling[]>(
      'stylings_get',
      this._apiUrl
    );
    this._endPointService.registerEndPoint<CompanyStyling>(
      'styling_get',
      this._apiUrl + '/current'
    );
    this._endPointService.registerEndPoint(
      'stylings_save',
      this._apiUrl + '/save',
      false
    );
  }

  public getCompanyStylings(fetch?: boolean): Observable<CompanyStylingWrapper> {
    return this._endPointService.call<CompanyStylingWrapper>(
      'stylings_get',
      null,
      fetch
    );
  }

  public getCompanyStyling(fetch?: boolean): Observable<CompanyStyling> {
    return this._endPointService.call<CompanyStyling>(
      'styling_get',
      null,
      fetch
    );
  }

  public saveCompanyStylings(
    companyStylings: CompanyStyling[],
    navigationLayout: number,
    sidebarWorksSynchronously: boolean
  ): Observable<void> {
    return this._endPointService.call('stylings_save', { stylings: companyStylings, hrNavigationLayout: navigationLayout, sidebarWorksSynchronously });
  }
}
